import React, { useContext, useState, useEffect } from "react";
import classes from "./TopNav.module.scss";

// import do texto alternativo de logo para o afinandinho sem skins
import { ALT_LOGO_AFINANDO } from "../../../constants/global";
// import do texto alternativo de logo para o afinandinho com skins de páscoa
import { ALT_LOGO_AFINANDO_PASCOA } from "../../../constants/global";
// import do texto alternativo de logo para o afinandinho com skins de festa junina
import { ALT_LOGO_AFINANDO_JUNINO } from "../../../constants/global";

import { Auth } from "aws-amplify";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as helpers from "../../../helpers/index";
import * as routes from "../../../constants/routes";

import ModalTour from "../../ModalTour/ModalTour";

// logo do afinandinho sem skins
import logoAfinando from "../../../assets/images/logo_afinando.png";

// logo do afinandinho com skins de páscoa
import logoCoelhoAfinandinho from "../../../assets/images/logo_pascoa.svg";

// logo do afinandinho com skins de festa junina
import logoJuninofinandinho from "../../../assets/images/logo_junino.png";

import personButtom from "../../../assets/images/SVG/personButtom.svg";

import SystemContext from "../../../context/SystemContext";
import { useDispatch, useSelector } from "react-redux";

import { Box, Typography } from "@mui/material";
import { useCycle } from "framer-motion";
import moment from "moment-timezone";
import useTimeBasedRender from '../../../hooks/useTimeBasedRender';

import MotionMenu from "../../UI/MotionMenu/MotionMenu";
import axios from "axios";
import { API_URL_STATIC_NOTIFY } from "../../../constants/api";
import { useSeasonalTheme } from '../../Navigation/hooks/useSeasonalTheme';
import AvatarManager from "components/Avatar/AvatarManager";

const TopNav = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isUserNavOpen, toggleUserNav] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [actualDay, setActualDay] = useState();
  const { session } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  const [permissions, setPermission] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const themes = [
    {
      name: 'pascoa',
      start: new Date("2026-03-05T00:00:00"),
      end: new Date("2026-04-15T23:59:59"),
      logo: logoCoelhoAfinandinho,
      alt: ALT_LOGO_AFINANDO_PASCOA,
      className: classes.LogoCoelhoAfinandinho,
      containerClassName: classes.LogoPascoa,
    },
    {
      name: 'junina',
      start: new Date('2025-06-01T00:00:00'),
      end: new Date('2025-07-29T23:59:59'),
      logo: logoJuninofinandinho,
      alt: ALT_LOGO_AFINANDO_JUNINO,
    },
  ];

  const getCurrentTheme = () => {
    const now = new Date();
    return themes.find(({ start, end }) => now >= start && now <= end);
  };

  const [menuContent, setMenuContent] = useState(null);

  useEffect(() => {
    if (session)
      setPermission(helpers.getUserPermission());
  }, [session]);

  const handleLogout = async () => {
    const allKeys = Object.keys(localStorage);
    const keysToKeep = ["persist:root"];

    allKeys.forEach((key) => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  };

  useEffect(() => {
    if (isLogout) {
      window.location.href = "/login";
      document.cookie.split(";").forEach(function (c) {
        document.cookie =
          c.trim().split("=")[0] +
          "=;" +
          "expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      });
      handleLogout();
    }
  }, [session, isLogout]);


  const now = moment();

  if (actualDay == null) setActualDay(moment(now).format("L"));

  const { setScrollable } = useContext(SystemContext) ?? {};


  const toggleUserNavHandler = (open = false) => {
    toggleUserNav(!isUserNavOpen);
    setScrollable(open);
  };

  let isFree = null;
  let isTrial = null;

  if (session && session.plans) {
    isFree = helpers.isFree(session.permissions, session.plans.permissions);
    isTrial = !!session.my_user.typeUser.includes("trial");
  }

  const getUserAvatarSection = (name) => {
    const preventReOpen = isUserNavOpen ? classes.PreventReOpen : "";
    return (
      <>
        {/* {_flags} */}
        <div className={classes.UserMenu + " " + preventReOpen}>
          <button className={classes.BtnAvatar}>

            {/* PASSADO COMPONENTE PARA TROCAR AVATAR */}
            <AvatarManager />

          </button>
        </div>
      </>
    );
  };


  const getBtnChangeUser = (isFree) =>
    location.pathname === routes.R_LIST_MY_USERS || !isFree ? null : (
      <NavLink
        to={routes.R_LIST_MY_USERS}
        style={{
          display: "inline-block",
          alignItems: "center",
          gap: "8px",
          backgroundColor: "#7B3CAA",
          padding: "8px 20px",
          borderRadius: "8px",
          marginLeft: 80,
          textDecoration: "none"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", width: "fit-content" }}>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              color: "#FCF8FF",
              fontWeight: 600,
            }}
          >
            {t("global.change_user")}
          </Typography>
          <Box
            component="img"
            src={personButtom}
            sx={{
              width: "1rem",
              height: "1rem"
            }}
          />
        </Box>
      </NavLink>
    );

  // console.log("plan_user", plan_user);

  // const _flags = getFlags();
  let userName = "";
  let userAvatarSection = null;
  let _btnToggleMenu = null;

  let _btnChangeUser = null;
  let _btnAfinandoPlusLogin = null;

  // const hasParent = helpers.hasParent();

  if (helpers.isAuthenticated(session)) {
    const user =
      Auth.user && Auth.user.attributes
        ? Auth.user?.attributes
        : Auth.user?.signInUserSession?.idToken.payload;
    userName = user?.given_name;
    userAvatarSection = getUserAvatarSection(userName);
    //_btnToggleMenu = getBtnToggleMenu(!isFree);
    _btnChangeUser = getBtnChangeUser(!isFree);
  }

  const [isOpen, toggleOpen] = useCycle(false, true);

  const [isOpenNotify, toggleOpenNotify] = useCycle(false, true);

  const sidebar = {
    open: (height = 1000) => ({
      clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2,
      },
      pointerEvents: "all",
      backgroundColor: ["#fafafa", "#fafafa"],
    }),
    closed: {
      clipPath: "circle(30px at 260px 40px)",
      transition: {
        delay: 0.5,
        type: "spring",
        stiffness: 400,
        damping: 40,
      },
      pointerEvents: "none",
      backgroundColor: ["#fafafa", "#fafafa"],
    },
  };
  const [notifications, setNotifications] = React.useState(null);

  React.useEffect(() => {
    axios.get(API_URL_STATIC_NOTIFY).then((response) => {
      setNotifications(response.data);
    });
  }, []);

  useEffect(() => {
    if (permissions && permissions.game != "view") {
      setMenuContent(
        <MotionMenu
          toggleOpen={toggleOpen}
          isOpen={isOpen}
          isOpenNotify={isOpenNotify}
          toggleOpenNotify={toggleOpenNotify}
          sidebar={sidebar}
          permissions={permissions}
          notification={notifications}
        ></MotionMenu>
      );
    }
  }, [permissions, isOpen, isOpenNotify, notifications]);

  const currentTheme = useSeasonalTheme();

  return (
    <>
      <ModalTour
        openModal={openModal}
        setOpenModal={setOpenModal}
        className={classes.ModalTour}
      />
      <header className={classes.TopNav}>
        <section className={classes.DesktopNav}>
          <div className={`${currentTheme?.containerClassName || classes.Logo} ${classes.LogoMobileTablet}`}>
            <NavLink to={routes.R_ROOT} exact="true">
              <figure>
                <img
                  src={currentTheme?.logoMobile || logoAfinando}
                  alt={currentTheme?.alt || ALT_LOGO_AFINANDO}
                  className={currentTheme?.className || classes.LogoAfinando}
                />
              </figure>
            </NavLink>
          </div>
          <section className={classes.LeftMenu}>{_btnChangeUser}</section>
          {_btnAfinandoPlusLogin}
          {menuContent}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "130px",
              height: "60px",
              left: "1200px",
            }}
            className="menu"
          >
            {_btnToggleMenu}{" "}
          </div>
        </section>

      </header>
    </>
  );
};

export default TopNav;